<template>
  <PopupBase
    class="popup-rfq-form"
    :show="props.show"
    :size="popupSizeSmall"
    close-on-outside-click
    @close-pop-up="emit('close-pop-up')"
  >
    <div class="popup-rfq-form__header">
      <h5>{{ i18n.tv('rfqPopupFormHeadline', 'partnerHub') }}</h5>
    </div>
    <div class="popup-rfq-form__body">
      <div class="popup-rfq-form__body__info">
        <div class="selected-product">
          <label class="rfq-form-label">{{ i18n.tv('rfqPopupFormLabelProduct', 'partnerHub') }}</label>
          <span class="selected-product-text">{{ productText }}</span>
        </div>
        <div class="selected-partner">
          <label class="rfq-form-label">{{ i18n.tv('rfqPopupFormLabelPartner', 'partnerHub') }}</label>
          <span class="selected-partner-name-address">{{ partnerTextNameAndAddress }}</span>
          <span class="selected-partner-zip-city">{{ partnerTextZipAndCity }}</span>
        </div>
      </div>
      <div class="popup-rfq-form__body__form">
        <ValidationForm
          ref="rfqValidationForm"
          :id="formId"
          use-model-values-for-validation
          :get-form="getForm"
          @success="submitForm"
        >
          <div class="rfq-form-row-1">
            <div class="rfq-form-column-left">
              <label
                id="rfq-quantity-label"
                class="rfq-form-label"
                for="rfq-quantity"
              >{{ i18n.tv('rfqPopupFormLabelQuantity', 'partnerHub') }} *</label>
              <NumericInput
                id="rfq-quantity"
                ref="validationFormQuantity"
                class="rfq-form-input-small"
                v-model="formData.quantity"
                aria-labelledby="rfq-quantity-label"
                :rules="[requiredNumberValidationRule(i18n.tv('rfqPopupFormLabelQuantity', 'partnerHub'))]"
              />
            </div>
            <div>
              <label
                id="rfq-delivery-date-label"
                class="rfq-form-label"
                for="rfq-delivery-date"
              >{{ i18n.tv('rfqPopupFormLabelDate', 'partnerHub') }}</label>
              <div @click="showDatePicker = true">
                <DatePicker
                  id="rfq-delivery-date"
                  ref="validationFormDeliveryDate"
                  class="rfq-form-input-small rfq-form-input-date-picker"
                  v-model="formData.deliveryDate"
                  aria-labelledby="rfq-delivery-date-label"
                  :custom-date-format="dateFormat"
                  :min="getNextDate()"
                  :max="getMaxDate()"
                  :show="showDatePicker"
                  @toggleCalender="showDatePicker = true"
                  @focus="handleDateFocus"
                  @blur="handleDateBlur"
                  @change="showDatePicker = false"
                />
              </div>
            </div>
          </div>
          <div class="rfq-form-row-2">
            <div class="rfq-form-column-left">
              <label
                id="rfq-company-label"
                class="rfq-form-label"
                for="rfq-company"
              >{{ i18n.tv('rfqPopupFormLabelCompany', 'partnerHub') }} *</label>
              <InputText
                id="rfq-company"
                ref="validationFormCompanyName"
                class="rfq-form-input-small"
                v-model="formData.company"
                name="companyName"
                aria-labelledby="rfq-company-label"
                :rules="[requiredValidationRule(i18n.tv('rfqPopupFormLabelCompany', 'partnerHub'))]"
                :placeholder="i18n.tv('rfqPopupFormPlaceholderCompany', 'partnerHub')"
              />
            </div>
            <div>
              <label
                id="rfq-first-name-label"
                class="rfq-form-label"
                for="rfq-first-name"
              >{{ i18n.tv('Frontend.TranslationContactFirstName', 'ORingConfiguratorImport') }} *</label>
              <InputText
                id="rfq-first-name"
                ref="validationFormFirstName"
                class="rfq-form-input-small"
                v-model="formData.firstName"
                name="firstName"
                aria-labelledby="rfq-first-name-label"
                :rules="[requiredValidationRule(i18n.tv('Frontend.TranslationContactFirstName', 'ORingConfiguratorImport'))]"
                :placeholder="i18n.tv('Frontend.PdfDownload.Placeholder.FirstName', 'ORingConfigurator')"
              />
            </div>
          </div>
          <div class="rfq-form-row-2a">
            <div class="rfq-form-column-left">
              <label
                id="rfq-last-name-label"
                class="rfq-form-label"
                for="rfq-last-name"
              >{{ i18n.tv('Frontend.TranslationContactLastName', 'ORingConfiguratorImport') }} *</label>
              <InputText
                id="rfq-last-name"
                ref="validationFormLastName"
                class="rfq-form-input-small"
                v-model="formData.lastName"
                name="lastName"
                aria-labelledby="rfq-last-name-label"
                :rules="[requiredValidationRule(i18n.tv('Frontend.TranslationContactLastName', 'ORingConfiguratorImport'))]"
                :placeholder="i18n.tv('Frontend.PdfDownload.Placeholder.LastName', 'ORingConfigurator')"
              />
            </div>
            <div />
          </div>
          <div class="rfq-form-row-3">
            <div class="rfq-form-column-left">
              <label
                id="rfq-email-label"
                class="rfq-form-label"
                for="rfq-email"
              >{{ i18n.tv('rfqPopupFormLabelEmail', 'partnerHub') }} *</label>
              <InputText
                id="rfq-email"
                ref="validationFormEmail"
                class="rfq-form-input-small"
                v-model="formData.email"
                name="email"
                aria-labelledby="rfq-email-label"
                :rules="[emailValidationRule(i18n.tv('rfqPopupFormLabelEmail', 'partnerHub'))]"
                :placeholder="'john.doe@yourcompany.com'"
              />
            </div>
            <div>
              <label
                id="rfq-phone-label"
                class="rfq-form-label"
                for="rfq-phone"
              >{{ i18n.tv('rfqPopupFormLabelPhone', 'partnerHub') }} *</label>
              <InputText
                id="rfq-phone"
                ref="validationFormPhone"
                class="rfq-form-input-small"
                v-model="formData.phone"
                name="phone"
                aria-labelledby="rfq-phone-label"
                :rules="[requiredValidationRule(i18n.tv('rfqPopupFormLabelPhone', 'partnerHub'))]"
                :placeholder="'+1 123 456 789'"
              />
            </div>
          </div>
          <div class="rfq-form-row-3a">
            <div class="rfq-form-column-left">
              <label
                id="rfq-country-label"
                class="rfq-form-label"
                for="rfq-country"
              >{{ i18n.tv('country', 'contactForm') }} *</label>
              <ComboDropDown
                id="rfq-country"
                ref="validationFormCountry"
                class="rfq-form-input-small"
                v-model="formData.country"
                aria-labelledby="rfq-country-label"
                :data-items="countryOptions"
                text-field="text"
                data-item-key="value"
                value-field="value"
                :value-primitive="true"
                :filterable="true"
                :rules="[requiredValidationRule(i18n.tv('country', 'contactForm'))]"
              />
            </div>
            <div v-if="!isLoggedIn">
              <label
                id="rfq-industry-type-label"
                class="rfq-form-label"
                for="rfq-industry-type"
              >{{ i18n.tv('rfqPopupFormLabelIndustry', 'partnerHub') }} *</label>
              <DropDown
                id="rfq-industry-type"
                ref="validationFormIndustryType"
                class="rfq-form-input-small"
                v-model="formData.industryType"
                aria-labelledby="rfq-industry-type-label"
                :data-items="industryTypeOptions"
                text-field="text"
                data-item-key="value"
                value-field="value"
                :value-primitive="true"
                :rules="!isLoggedIn ? [requiredValidationRule(i18n.tv('rfqPopupFormLabelIndustry', 'partnerHub'))] : []"
              />
            </div>
          </div>
          <div
            v-if="showSpecificIndustry && !isLoggedIn"
            class="rfq-form-row-3b"
          >
            <div>
              <label
                id="rfq-specific-industry-label"
                class="rfq-form-label"
                for="rfq-specific-industry"
              >{{ i18n.tv('rfqPopupFormLabelLeadMarket', 'partnerHub') }} *</label>
              <DropDown
                id="rfq-specific-industry"
                ref="validationFormSpecificIndustry"
                class="rfq-form-input-small"
                v-model="formData.specificIndustry"
                aria-labelledby="rfq-specific-industry-label"
                :data-items="specificIndustryOptions"
                text-field="text"
                data-item-key="value"
                value-field="value"
                :value-primitive="true"
                :rules="showSpecificIndustry && !isLoggedIn ? [requiredValidationRule(i18n.tv('rfqPopupFormLabelLeadMarket', 'partnerHub'))] : []"
              />
            </div>
          </div>
          <div class="rfq-form-row-4">
            <label
              id="rfq-comments-label"
              class="rfq-form-label"
              for="rfq-comments"
            >{{ i18n.tv('rfqPopupFormLabelComments', 'partnerHub') }}</label>
            <InputText
              id="rfq-comments"
              ref="validationFormComment"
              class="rfq-form-input-big"
              multiline
              v-model="formData.comments"
              name="comments"
              aria-labelledby="rfq-comments-label"
              :rows="4"
              @input-value="formData.comments = $event"
            />
          </div>
          <div class="rfq-form-row-5">
            <Checkbox
              ref="validationFormPrivacyPolicy"
              class="rfq-form-checkbox-1"
              v-model="formData.privacyPolicy"
              name="privacyPolicy"
              :value="formData.privacyPolicy"
              :label="privacyPolicyText"
              :use-markdown="true"
              :rules="[requiredCheckboxValidationRule('Field')]"
            />
            <Checkbox
              ref="validationFormAuthorizeInquiry"
              class="rfq-form-checkbox-2"
              v-model="formData.authorizeInquiry"
              :value="formData.authorizeInquiry"
              :label="i18n.tv('rfqPopupFormLabelAuthorizeInquiry', 'partnerHub')"
              :rules="[requiredCheckboxValidationRule('Field')]"
            />
            <div class="rfq-form-legal-statement">
              <Markdown :text="i18n.tv('rfqPopupFormLegalStatement', 'partnerHub')" />
            </div>
          </div>
          <div class="rfq-form-row-mandatory">
            <span class="mandatory-fields">
              {{ i18n.tv('mandatoryFields', 'contactForm') }}
            </span>
          </div>
          <div class="rfq-form-row-6">
            <ReactiveButton
              type="submit"
              :button-text="i18n.tv('rfqPopupFormSubmit', 'partnerHub')"
              :is-primary-button="false"
              :is-loading="isLoading"
            />
          </div>
          <input
            hidden
            name="firstName"
            :value="formData.firstName"
          >
          <input
            hidden
            name="lastName"
            :value="formData.lastName"
          >
          <input
            hidden
            name="description"
            :value="formCaptureDescription"
          >
          <input
            hidden
            name="subject"
            value="EASY PartnerHub RFQ"
          >
          <input
            v-if="!isLoggedIn"
            hidden
            name="initialIndustry"
            :value="formData.industryType"
          >
          <input
            hidden
            name="marketingLanguage"
            :value="formCaptureMarketingLanguage"
          >
          <input
            hidden
            name="country"
            :value="formCaptureCountry"
          >
          <input
            hidden
            name="leadMarket"
            :value="formData.specificIndustry"
          >
          <!-- ERP fields for logged-in users -->
          <input
            v-if="isLoggedIn"
            hidden
            name="easyAccountNumber"
            :value="companyNo"
          >
          <input
            v-if="isLoggedIn"
            hidden
            name="easySalesOrganization"
            :value="salesOrganization"
          >
          <!-- Metadata field (always present) -->
          <input
            hidden
            name="metadata"
            :value="formCaptureMetadata"
          >
        </ValidationForm>
      </div>
    </div>
  </PopupBase>
</template>

<script setup lang="ts">

import ValidationForm from '~/components/input-components/ValidationForm.vue'
import NumericInput from '~/components/input-components/NumericInput.vue'
import DatePicker from '~/components/input-components/DatePicker.vue'
import InputText from '~/components/input-components/InputText.vue'
import Checkbox from '~/components/input-components/Checkbox.vue'
import DropDown from '~/components/input-components/DropDown.vue'
import ComboDropDown from '~/components/input-components/ComboDropDown.vue'
import useI18nExtended from '~/composables/usei18nExtended'
import {getMaxDate, getNextDate} from 'assets/js/utils'
import {
  emailValidationRule,
  requiredCheckboxValidationRule, requiredNumberValidationRule,
  requiredValidationRule
} from 'assets/js/validations/common_validation_rules'
import {useMailService} from '~/composables/mail_service'
import type {RFQRequestBody} from '~/composables/mail_service'
import {API_INDICATORS, POPUP} from 'assets/js/constants'
import {REGION_KEYS} from 'assets/js/constants.js'
import {useGtm} from '@gtm-support/vue-gtm'
import {usePartnerHubHelper} from '~/composables/partner_hub_helper'
import {useDynamicsLeadCapture} from '~/composables/useDynamicsLeadCapture'
import {useFormDropdowns} from '~/composables/useFormDropdowns'
import {useFormPrefill} from '~/composables/useFormPrefill'
import {useFormPrivacyText} from '~/composables/useFormPrivacyText'
import {generateFormId} from '~/utils/generateFormId'
import {getProductText} from 'assets/js/utils/product'
import {useUserStore} from '@/store/user'
import {storeToRefs} from 'pinia'

const userStore = useUserStore()
const {showInchValues} = storeToRefs(userStore)

// Check if user is logged in
const isLoggedIn = computed(() => userStore.loggedIn)

// ERP fields for logged-in users
const companyNo = computed(() => {
  if (!isLoggedIn.value) {return ''}
  return (userStore.selectedCustomer as any)?.customerNo || ''
})

const salesOrganization = computed(() => {
  if (!isLoggedIn.value) {return ''}
  const c = userStore.selectedCustomer as any
  if (!c?.salesOrg) {return ''}
  return `${c.salesOrg}-${c.salesChannel}-${c.distribution}`
})

const app = useNuxtApp()
const i18n = useI18nExtended()
const {postRFQRequest} = useMailService()
const {loadCRMFormCapture} = usePartnerHubHelper()
const dynamicsCapture = useDynamicsLeadCapture()
const {getExtendedPrefillData} = useFormPrefill()
const {
  countryOptions,
  industryTypeOptions,
  specificIndustryOptions,
  shouldShowSpecificIndustry
} = useFormDropdowns()
const {privacyPolicyText} = useFormPrivacyText()
const emit = defineEmits(['close-pop-up'])

onMounted(() => {
  loadCRMFormCapture(formId.value)
})

const popupSizeSmall = POPUP.Size.small

const props = defineProps({
  show: {
    type: Boolean,
    default() {
      return false
    }
  },
  product: {
    type: Object,
    required: true,
    default() {
      return {}
    }
  },
  partner: {
    type: Object,
    required: true,
    default() {
      return {}
    }
  }
})

// Form data with prefilling from shared composable
const prefillData = getExtendedPrefillData()
const formData = ref({
  quantity: null as number | null,
  deliveryDate: getNextDate(),
  company: prefillData.company,
  firstName: prefillData.firstName,
  lastName: prefillData.lastName,
  email: prefillData.email,
  phone: prefillData.phone,
  comments: '',
  country: prefillData.country || null,
  industryType: (prefillData.industryType ? Number(prefillData.industryType) : null) as number | null,
  specificIndustry: (prefillData.specificIndustry ? Number(prefillData.specificIndustry) : null) as number | null,
  leadMarket: prefillData.leadMarket || null,
  privacyPolicy: false,
  authorizeInquiry: false
})

const formId = ref(generateFormId('rfqValidationForm'))
const datePickerBlurTimeout = ref()
let showDatePicker = ref<boolean>(false)
let isLoading = ref<boolean>(false)

// Conditional display for Specific Industry dropdown (labeled as Lead Market)
const showSpecificIndustry = computed(() => {
  return shouldShowSpecificIndustry(formData.value.industryType)
})

const productText = computed(() => {
  return getProductText(props.product, i18n.locale.value, showInchValues.value)

})

const partnerTextNameAndAddress = computed(() => {
  return `${props.partner.supplier} - ${props.partner.street}`
})

const dateFormat = computed(() => {
  return app.$globalization.__currentRegion === REGION_KEYS.NA ? 'MM/dd/yyyy' : 'dd.MM.yyyy'
})

const partnerTextZipAndCity = computed(() => {
  return `${props.partner.zip} ${props.partner.city} ${props.partner.addressRegion ? `(${props.partner.addressRegion})` : ''}`
})

const formCaptureDescription = computed(() => {
  // Only include user comments, metadata goes to separate field
  return formData.value.comments || ''
})

const formCaptureMetadata = computed(() => {
  const formattedDate = app.$formatDate(formData.value.deliveryDate, dateFormat.value)
  return dynamicsCapture.buildDescriptionAppendix({
    formType: 'partnerHub',
    product: {
      description: productText.value
    },
    partnerHub: {
      partner: partnerTextNameAndAddress.value + ', ' + partnerTextZipAndCity.value,
      quantity: formData.value.quantity ?? undefined,
      deliveryDate: formattedDate
    }
  })
})
const formCaptureMarketingLanguage = computed(() => {
  return dynamicsCapture.getLanguageObject(i18n.locale.value)
})
const formCaptureCountry = computed(() => {
  return dynamicsCapture.getCountryObject(formData.value.country || undefined)
})

const getForm = () => {
  return formData.value
}
const handleDateBlur = () => {
  datePickerBlurTimeout.value = setTimeout(() => {
    showDatePicker.value = false
  }, 50)
}
const handleDateFocus = () => {
  if (datePickerBlurTimeout.value) {
    clearTimeout(datePickerBlurTimeout.value)
  }
}

const trackRFQRequest = () => {
  useGtm()?.trackEvent({
    event: 'partnerh_rfq',
    category: 'partner_hub',
    ecommerce: {
      sku: props.product.sku,
      distributor: props.partner.supplier
    }
  })
}

const getProductUrl = () => {
  const productsPath = app.$globalization.localePath(`/products/${props.product.sku}`)
  const domain = window.location.origin
  return `${domain}${productsPath}`
}

const submitForm = () => {
  isLoading.value = true
  const formattedDate = app.$formatDate(formData.value.deliveryDate, dateFormat.value)

  const requestBody: RFQRequestBody = {
    indicator: API_INDICATORS.PARTNER_HUB,
    customerUuid: userStore.selectedCustomer?.customerUuid === 'default' ? null : (userStore.selectedCustomer?.customerUuid || null),
    userUuid: userStore.userUuid === '' ? null : (userStore.userUuid || null),
    email: formData.value.email,
    firstName: formData.value.firstName,
    lastName: formData.value.lastName,
    company: formData.value.company,
    phone: formData.value.phone,
    message: formData.value.comments,
    payload: {
      salesText: productText.value,
      sku: props.product.sku,
      supplierName: props.partner.supplier,
      supplierMail: props.partner.mail,
      quantity: formData.value.quantity ?? 0,
      wishedDeliveryDate: formattedDate,
      productUrl: getProductUrl()
    }
  }

  postRFQRequest(requestBody).then(() => {
    app.$toast.success(i18n.tv('rfqPopupFormToastSuccess', 'partnerHub'))
    isLoading.value = false
    emit('close-pop-up')
    trackRFQRequest()
  }).catch(() => {
    app.$toast.error(i18n.tv('rfqPopupFormToastError', 'partnerHub'))
    isLoading.value = false
  })
}

// Reset form data to initial prefilled state
const resetForm = () => {
  const freshPrefill = getExtendedPrefillData()
  formData.value = {
    quantity: null,
    deliveryDate: getNextDate(),
    company: freshPrefill.company,
    firstName: freshPrefill.firstName,
    lastName: freshPrefill.lastName,
    email: freshPrefill.email,
    phone: freshPrefill.phone,
    comments: '',
    country: freshPrefill.country || null,
    industryType: (freshPrefill.industryType ? Number(freshPrefill.industryType) : null) as number | null,
    specificIndustry: (freshPrefill.specificIndustry ? Number(freshPrefill.specificIndustry) : null) as number | null,
    leadMarket: freshPrefill.leadMarket || null,
    privacyPolicy: false,
    authorizeInquiry: false
  }
}

// Reset form when popup opens
watch(
  () => props.show,
  (isVisible) => {
    if (isVisible) {
      resetForm()
    }
  }
)

</script>

<style lang="scss">
.popup-rfq-form {
  .rfq-form-label {
    font-weight: 300;
    font-size: 0.875rem;
    margin-bottom: 0.313rem;
  }

  &__header {
    h5 {
      margin: -.5rem 0 1rem;
    }
  }

  &__body {
    max-width: 30.813rem;

    ::placeholder {
      opacity: 0.5;
    }

    &__info {
      .selected-product {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }

      .selected-partner {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 1rem;
      }
    }

    &__form {
      .rfq-form-input-small {
        width: 14.594rem;
        margin-top: 0.375rem;
      }

      .rfq-form-input-big {
        padding-top: 0.375rem;

        textarea {
          resize: none;
        }
      }

      .rfq-form-column-left {
        margin-right: 1.5rem;
      }

      .rfq-form-row-1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .75rem;

        span {
          min-height: 0;
        }

        .rfq-form-input-date-picker {
          border: .0625rem solid $color--input__border;

          .k-input-inner {
            border-top: none;
            border-right: .0625rem solid $color--input__border;
            border-bottom: none;
            border-left: none;
            font-weight: 520;
          }

          .k-button.k-button-md.k-icon-button.k-button-solid.k-button-solid-base.k-input-button {
            margin-left: 0;
          }
        }
      }

      .rfq-form-row-2 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 1.5rem;

        span {
          min-height: 0;
        }
      }

      .rfq-form-row-2a {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 1.5rem;

        span {
          min-height: 0;
        }
      }

      .rfq-form-row-3 {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 1.5rem;

        span {
          min-height: 0;
        }
      }

      .rfq-form-row-3a {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 1.5rem;

        span {
          min-height: 0;
        }
      }

      .rfq-form-row-3b {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 1.5rem;

        span {
          min-height: 0;
        }
      }

      .rfq-form-row-4 {
        margin-top: 1.5rem;
      }

      .rfq-form-row-5 {
        margin-top: 1.5rem;

        .rfq-form-checkbox-1 {
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
          flex-direction: column;

          span {
            min-height: 0;
          }
        }

        .rfq-form-checkbox-2 {
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
          flex-direction: column;
          margin-top: 1rem;

          span {
            min-height: 0;
          }
        }

        label {
          font-weight: 300;
          font-size: 0.875rem;
          cursor: default;
        }
      }

      .rfq-form-row-mandatory {
        margin-top: 1.5rem;

        .mandatory-fields {
          font-size: 0.875rem;
          font-weight: $base-text-font-weight-light;
        }
      }

      .rfq-form-row-6 {
        display: flex;
        justify-content: flex-end;
        margin-bottom: -.5rem;
        margin-top: 2rem;
      }

      // ComboBox (country field) styling fixes
      .k-combobox {
        border: .0625rem solid $color--input__border;

        .k-input-button {
          .k-icon {
            min-height: auto;
            width: 2.5rem;
            background-color: transparent;
            color: $color__fst_gray__100;
            padding: .5rem;
          }
        }

        &.k-input:focus {
          border-color: $color--input__border;
        }
      }
    }
  }
}

// Override buy-box-new popup wrapper rule for RFQ form (third level popup)
.popup.popup__buy-box-new .popup-rfq-form {
  .popup__wrapper {
    max-width: 35rem !important;
    width: 100%;
  }
}
</style>
